import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { MdCancel } from 'react-icons/md';
import { useTranslation } from 'react-i18next';


const ModalErrors = ({modalTitle, modalBody, handleClose}) => {
    const {t} = useTranslation("global");

    return(
        <Modal
            show = {true}
            onHide={()=>  handleClose(false)}
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {modalTitle}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ display : "flex", flexDirection : "column", alignItems : "center", position : "relative" }}>
                <MdCancel
                    size={ 120 }
                    style={{ color : "#BB2D3B", marginBottom : 20 }}
                />
                <div
                    style={{
                        maxWidth : "100%",
                        wordWrap : 'break-word'
                    }}
                >
                    {modalBody}
                </div>
            </Modal.Body>   
            <Modal.Footer>
                <Button onClick={()=> handleClose(false)}>{t("login.close")}</Button>
            </Modal.Footer>     
        </Modal>
    )
}

export default ModalErrors